import { parsePhoneNumber } from 'libphonenumber-js';

// export const formatPhoneNumber = (phoneNumberString) => {
//     let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
//     let match = cleaned.match(/^([0-9])?(\d{3})(\d{3})(\d{4})$/);
//     if (match) {
//         let intlCode = match[1] ? `+${match[1]} ` : '';
//         return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join(
//             '',
//         );
//     }
//     return '';
// };

export const formatPhoneNumber = (value) => {
    if (!value) return '';
    try {
        if (!value.startsWith('+')) {
            value = `+${value}`;
        }
        const phone = parsePhoneNumber(value);

        if (!phone) return '';
        return phone.formatInternational();
    } catch (error) {
        console.error(error);
        return '';
    }
};
